import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ClientStatusInfo } from 'actions/actionTypes';
import * as actions from 'actions/clientStatus/info';

import { callShopClientLimitSetting, callGameRoundSetting } from 'network/apis/clientStatus/info';

// 클라이언트 정보 조회 사가 함수
function* loadClientInfoRequestSaga() {
    try {
        const manager = yield select(state => state.manager);
        const clientStatusInfo = yield select(state => state.clientStatusInfo);

        const response = yield call(callShopClientLimitSetting, manager.manager.shopGuid, clientStatusInfo.clientGuid);

        yield put(actions.loadClientStatusInfoSuccess(response.data));
    } catch(error) {
        yield put(actions.loadClientStatusInfoFailure(error.response.data.error.message));
    }
}

// 게임 라운드 설정 조회 사가 함수
function* loadGameRoundSettingRequestSaga() {
    try {
        const clientStatusInfo = yield select(state => state.clientStatusInfo);

        const response = yield call(callGameRoundSetting, clientStatusInfo.data.gameRoundId);

        yield put(actions.loadGameRoundSettingSuccess(response.data));
    } catch(error) {
        yield put(actions.loadGameRoundSettingFailure(error.response.data.error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(ClientStatusInfo.LOAD_CLIENT_STATUS_INFO_REQUEST, loadClientInfoRequestSaga),
        takeLatest(ClientStatusInfo.LOAD_GAME_ROUND_SETTING_REQUEST, loadGameRoundSettingRequestSaga),
    ]);
}